import { InventoryLocationDto } from "../models"
import { NormalizedLocation } from "./types"

export const stateHandler = (state) => {
    return {
        fetchListingSuccess: (res: InventoryLocationDto[]) => {
            return {
                ...state ,
                listing: res?.map(item => { 
                    return {    
                        id: item.id,
                        ...item.attributes
                    } 
                }) ?? [],
                
            }
        },
        
        setName: (payload) => {
            return {
                ...state,
                name: payload,
            }
        },
        
        setLocationIds: (payload) => {
            return {
                ...state,
                locationIds: payload,
            }
        },

        setFromListing: ( payload ) => {
            const current: NormalizedLocation = state.listing.find((item) => item.id == payload)
            if (current !== undefined){
                return {
                    ...state,
                    id: current.id,
                    name: current.name,
                    locationIds:current.locationIds,
                    locations: current.locations
                }
            }
            return {... state }

        },
        
        submitSuccess: () => {
            return {
                ...state,
                fetchSuccess: true,
            }
        },
        
        submitFail: (errorMessage: string) => {
            return {
                ...state,
                isError: true,
                errorMessage: errorMessage,
            }
        },
        
        clearLocation: () => {
            return {
                ...state,
                id: "",
                name: "",
                locationIds: [],
                locations: [],
                isError: false,
                fetchSuccess: false,
                errorMessage: "",
            }
        },
        
        deleteSuccess: () => {
            return {
                ...state,
                fetchSuccess: true,
            }
        },
        
        deleteFail: (errorMessage: string) => {
            return {
                ...state,
                isError: true,
                errorMessage: errorMessage,
            }
        },

        setInventoryLocation: (payload: InventoryLocationDto | undefined) => {
            if(payload !== undefined) {
                return {
                    ...state,
                    id: payload.id,
                    name: payload.attributes.name,
                    locationIds: payload.attributes.locationIds,
                    locations: payload.attributes.locations,
                }
            }
        },
    }
}




// WEBPACK FOOTER //
// ./src/state/inventory/location/reducers/handler.ts